import { NgModule, Type } from '@angular/core';
import { SharedModule } from '@shared';
// single pages
import { CallbackComponent } from './passport/callback.component';
import { UserLockComponent } from './passport/lock/lock.component';
// passport pages
import { UserLoginComponent } from './passport/login/login.component';
import { UserRegisterResultComponent } from './passport/register-result/register-result.component';
import { UserRegisterComponent } from './passport/register/register.component';
import { PasswordSetComponent } from './passport/password-set/password-set.component';
import { LoadingComponent } from './passport/loading/loading.component';
import { RouteRoutingModule } from './routes-routing.module';
import { ComponentModule } from '../modules/component/component.module';

const COMPONENTS: Type<void>[] = [
  // passport pages
  UserLoginComponent,
  UserRegisterComponent,
  UserRegisterResultComponent,
  PasswordSetComponent,
  LoadingComponent,
  // single pages
  CallbackComponent,
  UserLockComponent,
];
const COMPONENTS_NOROUNT: Type<void>[] = [];

@NgModule({
  imports: [SharedModule, RouteRoutingModule, ComponentModule],
  declarations: [...COMPONENTS, ...COMPONENTS_NOROUNT],
})
export class RoutesModule {}
